import React, { useState } from "react";
import { Box, Card, Grid, Typography, TextField, InputAdornment, FormControl, Skeleton } from "@mui/material";
import { Search } from "@mui/icons-material";
import Base from "../../../Base/views/Base";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react'
import HolidayCalender from "./HolidayCalender";
import { GetYearlyHolidayCalendarAction } from "../../../../../store/Leave/YearlyHolidayCalendar/Action";
import SelectableSearch from "../../../Base/views/SelectableSearch";

const Holidays = () => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const { holidayData, isLoading } = useSelector(state => state?.LeaveReducer?.YearlyHolidayCalendarReducer) || {};
    const filteredHolidays = (holidayData || [])
    .filter(holiday =>
        holiday.name.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => new Date(a.date) - new Date(b.date));
    const [years, setYears] = useState({ load: true, values: [] });
    const [selectyear, setselectYear] = useState(false);
    const [data, setData] = useState({ year: { id: 0, "year": `${new Date().getFullYear()}` } });
    useEffect(() => {
        dispatch(GetYearlyHolidayCalendarAction({ year: data?.year?.year ? data?.year?.year : 0 }));
        getYears();
    }, [data]);
    const getYears = () => {
        let year = []
        const cur_year = new Date().getFullYear() - 5;
        for (var i = 1; i <= 5; i++) {
            year.splice(0, 0, { id: i, "year": `${cur_year + i}` });
        }
        setYears({ load: false, values: year });
    }
    const handleChange = (event, value) => {
        if (event === "year") {
            setData({ ...data, [event]: value });
            setselectYear(true);
        } else {
            setData({ ...data, [event.target.name]: event.target.value })
        }
    }
    const handleExternalYearChange = (yearNumber) => {
        const selectedYearObj = years.values.find(y => y.year === `${yearNumber}`);
        if (selectedYearObj) {
            setData(prev => ({ ...prev, year: selectedYearObj }));
        }
    };
    return (
        <Base>
            <Box p={1} sx={{ maxHeight: "87vh", overflowY: "auto" }}>
                <Grid container spacing={1.5}>
                    <Grid item xs={12} md={5}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography variant="h4" fontWeight="bold">
                                Holidays
                            </Typography>
                            <FormControl sx={{ minWidth: 120 }}>
                                <SelectableSearch
                                    label="Year"
                                    value={data?.year}
                                    fieldLabel="year"
                                    loading={getYears}
                                    variant="outlined"
                                    name="year"
                                    size="small"
                                    onChangeEvent={handleChange}
                                    data={years}
                                />
                            </FormControl>
                        </Box>
                        <Typography variant="body2" sx={{ color: "#8a93a2", mt: 1 }}>
                            <span style={{ fontWeight: "bolder" }}>{filteredHolidays.length}</span> Holidays in Total
                        </Typography>
                        <TextField
                            placeholder="Search by Holiday"
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                )
                            }}
                        />
                        <Box
                            sx={{
                                maxHeight: "425px",
                                overflowY: "auto",
                                scrollbarWidth: "none",
                                "&::-webkit-scrollbar": { display: "none" }
                            }}
                        >
                            {
                                isLoading ? (
                                    Array.from({ length: 5 }).map((_, index) => (
                                        <Card
                                            key={index}
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "flex-start",
                                                p: 2,
                                                my: 1,
                                                bgcolor: "#f9f6ff",
                                                borderRadius: 2,
                                                boxShadow: 1
                                            }}
                                        >
                                            <Box sx={{ flex: 1 }}>
                                                <Skeleton width="60%" height={25} />
                                                <Skeleton width="40%" height={20} sx={{ mt: 1 }} />
                                                <Skeleton width="80%" height={20} sx={{ mt: 1 }} />
                                            </Box>
                                            <Skeleton
                                                variant="rectangular"
                                                width={70}
                                                height={28}
                                                sx={{
                                                    borderRadius: "16px",
                                                    bgcolor: "#ece9fe",
                                                    mt: 1
                                                }}
                                            />
                                        </Card>
                                    ))
                                ) : filteredHolidays.length > 0 ? (
                                    filteredHolidays.map((holiday, index) => (
                                        <Card
                                            key={index}
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                p: 2,
                                                my: 1,
                                                bgcolor: "#f9f6ff",
                                                borderRadius: 2,
                                                boxShadow: 1
                                            }}
                                        >
                                            <Box>
                                                <Typography fontWeight="bold" fontSize="1rem">{holiday.name}</Typography>
                                                <Typography fontWeight="body2" sx={{ mt: 0.5 }}>{holiday.description}</Typography>
                                            </Box>
                                            <Box  sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap:"5px" }}>
                                                <Typography variant="body2" sx={{ color:        "#883bd5", fontWeight: "bold" }}>
                                                        {new Date(holiday?.date).toLocaleDateString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric"
                                                    })}
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        backgroundColor: "#ece9fe",
                                                        color: "#818181",
                                                        fontWeight: "bold",
                                                        fontSize: "0.75rem",
                                                        px: 1.5,
                                                        py: 0.5,
                                                        borderRadius: "16px",
                                                        whiteSpace: "nowrap",
                                                        minWidth: "70px",
                                                        textAlign: "center"
                                                    }}
                                                >
                                                    {holiday.dow}
                                                </Box>
                                                
                                            </Box>
                                        </Card>
                                    ))
                                ) : (
                                    <Typography
                                        variant="body2"
                                        sx={{ color: "#8a93a2", textAlign: "center", mt: 3 }}
                                    >
                                        No holidays found.
                                    </Typography>
                                )
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={7}>
                        <HolidayCalender
                            holidayData={holidayData}
                            selectedYear={data?.year?.year || new Date().getFullYear()}
                            selectyear={selectyear}
                            disableViewType={true}
                            onCalendarYearChange={handleExternalYearChange} />
                    </Grid>
                </Grid>
            </Box>

        </Base>
    );
};

export default Holidays;
